module.exports = __webpack_public_path__ + "11285db88f4c2fc2520f2644d31fefea.woff";